import { OpenAPI } from './services';
import env from './configs/env';
import { initRum } from './configs/rum';

const init = () => {
    OpenAPI.BASE = env.BACKEND_BASE_URL;
    OpenAPI.WITH_CREDENTIALS = true;

    // CloudWatch RUM 操作ログ
    initRum();
};

export default init;
